import common from 'store/modules/common/api'

export const api = {
  ...common.apiMethods('StaticFilters'),
  getByPage: (page) => common.httpClient.get(`/api/services/app/StaticFilters/GetByPage?page=${page}`, common.options()).then(r => common.processResponse(r)),
}
